







































































































import Vue, { PropType } from 'vue'
import { getImageUrl } from '@/utils/helper'
import {
  programLevelLabels,
  programGenderLabels,
  ProgramWithTimetables,
  groupTimetablesByAvailableDateAndTimeSpan,
} from '@/core/Programs'
import { Timetable } from '@/core/Timetables'

const TIMETABLE_DISPLAY_LIMIT = 4

export default Vue.extend({
  props: {
    component: {
      type: String,
      default: 'div',
    },
    facilityPath: {
      type: String,
      default: '',
    },
    program: {
      type: Object as PropType<ProgramWithTimetables>,
      required: true,
    },
    isOnline: {
      type: Boolean,
      default: false,
    },
    embed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    levelLabel(): string {
      return programLevelLabels[this.program.level]
    },
    sexLimitationLabel(): string {
      return programGenderLabels[this.program.sexLimitation]
    },
    formattedPoint(): string {
      return this.program.minimumPoint
        ? this.$numberFormat(this.program.minimumPoint) + 'pt~'
        : this.program.minTimetablePoint === this.program.maxTimetablePoint
        ? this.$numberFormat(this.program.minTimetablePoint || 0) + 'pt'
        : this.$numberFormat(this.program.minTimetablePoint || 0) + 'pt~'
    },
    groupedTimetables(): {
      [date: string]: { [timespan: string]: Timetable[] }
    } {
      return groupTimetablesByAvailableDateAndTimeSpan(
        this.program.timetables,
        TIMETABLE_DISPLAY_LIMIT
      )
    },
  },
  updated() {
    this.$emit('updated')
  },
  methods: {
    getImageUrl: getImageUrl,
    hasStock(timetables: Timetable[]): boolean {
      if (!timetables) return false
      return timetables.reduce((acc, timetable) => acc + timetable.stock, 0) > 0
    },
  },
})
